/**
 * HomePage.jsx içindeki şerit ve hizmet grid sırasıyla uyumlu id + çeviri anahtarları (admin listesi).
 */
export const QUICK_STRIP_SECTION_META = [
  { id: 'turk-restoranlari', nameKey: 'home.services.restaurants' },
  { id: 'ucak-bileti', nameKey: 'home.services.flights' },
  { id: 'otel-rezervasyon', nameKey: 'home.services.hotels' },
  { id: 'taxi-limuzin', nameKey: 'home.services.taxiLimo' },
  { id: 'aktar', nameKey: 'home.services.transfer' },
  { id: 'turk-marketleri', nameKey: 'home.services.markets' },
  { id: 'diger-hizmetler', nameKey: 'home.services.other' },
  { id: 'mutfak', nameKey: 'categories.mutfak' },
  { id: 'yatak-odasi', nameKey: 'categories.yatakOdasi' },
  { id: 'giyim-moda', nameKey: 'categories.giyimModa' },
  { id: 'kadin-giyim', nameKey: 'categories.kadinGiyim' },
  { id: 'spor', nameKey: 'categories.spor' },
  { id: 'ev-yasam', nameKey: 'categories.evYasam' },
  { id: 'aksesuar', nameKey: 'categories.aksesuar' },
  { id: 'bijuteri', nameKey: 'bijuteri.title' },
  { id: 'bahce', nameKey: 'categories.bahce' },
  { id: 'kozmetik', nameKey: 'categories.kozmetik' },
  { id: 'hediyelik', nameKey: 'categories.hediyelik' },
  { id: 'elektronik', nameKey: 'categories.elektronik' },
  { id: 'bebek', nameKey: 'categories.bebek' },
  { id: 'oto-aksesuar', nameKey: 'categories.otoAksesuar' },
  { id: 'oto-lastik', nameKey: 'categories.otoLastik' },
];

export const SERVICES_GRID_META = [
  { id: 'svc-supermarkets', nameKey: 'services.turkishSupermarkets' },
  { id: 'svc-restaurants', nameKey: 'services.turkishRestaurants' },
  { id: 'svc-car-rental', nameKey: 'services.carRental' },
  { id: 'svc-taxi', nameKey: 'services.taxiLimousine' },
  { id: 'svc-flights', nameKey: 'services.flights' },
  { id: 'svc-hotels', nameKey: 'services.hotels' },
  { id: 'svc-auto-parts', nameKey: 'services.autoParts' },
  { id: 'svc-tires', nameKey: 'services.tires' },
];
